var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.9505V37.9955C23.745 37.9955 23.475 37.9505 23.265 37.8305L23.205 37.8005C20.325 36.2255 15.3 34.5755 12.045 34.1405L11.61 34.0805C10.17 33.9005 9 32.5505 9 31.1105V12.9905C9 11.2055 10.455 9.85553 12.24 10.0055C15.39 10.2605 20.16 11.8505 22.83 13.5155L23.205 13.7405C23.43 13.8755 23.715 13.9505 24 13.9505Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13.0043V31.1093C39 32.5493 37.83 33.8993 36.39 34.0793L35.895 34.1393C32.625 34.5743 27.585 36.2393 24.705 37.8293C24.51 37.9493 24.27 37.9943 24 37.9943V13.9493C24.285 13.9493 24.57 13.8743 24.795 13.7393L25.05 13.5743C27.72 11.8943 32.505 10.2893 35.655 10.0193H35.745C37.53 9.86931 39 11.2043 39 13.0043Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 19.8594H14.25C13.635 19.8594 13.125 19.3494 13.125 18.7344C13.125 18.1194 13.635 17.6094 14.25 17.6094H17.625C18.24 17.6094 18.75 18.1194 18.75 18.7344C18.75 19.3494 18.24 19.8594 17.625 19.8594Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 24.3594H14.25C13.635 24.3594 13.125 23.8494 13.125 23.2344C13.125 22.6194 13.635 22.1094 14.25 22.1094H18.75C19.365 22.1094 19.875 22.6194 19.875 23.2344C19.875 23.8494 19.365 24.3594 18.75 24.3594Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook2);
export default __webpack_public_path__ + "static/media/book2.8d7ca71e41b9cb76e5cda7aaa20e39d0.svg";
export { ForwardRef as ReactComponent };